import { InputLocalizationType } from '~src/domains/common/types/forms';
import { createDefaultFormMeta, createFormMetaSlice } from '~src/utils/forms';
import { FullSSNFormNames } from '~src/domains/common/enums/common';

export type FullSSNLocalization = {
  [key: string]: InputLocalizationType;
};

const formMetaDefault = createDefaultFormMeta([
  [FullSSNFormNames.FULL_SSN, ''],
]);

export const fullSSNFormSlice = createFormMetaSlice(
  'fullSSNForm',
  formMetaDefault,
);

export const {
  updateInputValue,
  updateInputHidden,
  updateInputIsValid,
  registerInputLabel,
  registerValidityConfig,
  registerPostProcess,
} = fullSSNFormSlice.actions;

export default fullSSNFormSlice.reducer;
